/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-await-in-loop */
import React, { memo, useEffect, useLayoutEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Popconfirm,
  Row,
  Select,
  Tabs,
  TimePicker,
  Upload,
} from 'antd';
import axios from 'axios';
import Inputmask from 'inputmask';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

import { CloseOutlined, DeleteOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';

import CompanyFunctions from '../../../Assets/Scripts/CompanyFunctions';
import Utils from '../../../Assets/Scripts/Utils';
import {
  applyRegisterCustomFields,
  createRegisterShowField,
  RegisterLayoutBody,
  useRegisterFieldLayout,
} from '../../../Components/ResourceFieldLayout/RegisterFieldLayout';
import TableAntd from '../../../Components/TableAntd/TableAntd';
import { api } from '../../../Services/axiosService';
import { deleteFileDocuments, uploadFiles } from '../../../Services/firebaseService';

let canHandleInstructor = false;

const { Search } = Input;

const workDaysOptions = [
  { label: 'Selecionar todos', value: 'selectAll' },
  { label: 'Segunda', value: '1' },
  { label: 'Terça', value: '2' },
  { label: 'Quarta', value: '3' },
  { label: 'Quinta', value: '4' },
  { label: 'Sexta', value: '5' },
  { label: 'Sábado', value: '6' },
  { label: 'Domingo', value: '0' },
];

function InstructorRegisterPage() {
  const { id: editId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const { fieldLayout, roleId } = useRegisterFieldLayout('Instructor');
  const showField = createRegisterShowField(fieldsPermissions, fieldLayout, roleId);
  const [documentTypeOptions, setDocumentTypeOptions] = useState();
  const [screenModified, setScreenModified] = useState(false);
  const [trainingsOptions, setTrainingsOptions] = useState();
  const [trainingCenterOptions, setTrainingCenterOptions] = useState();
  const [requiredDocuments, setRequiredDocuments] = useState();
  const [signatureFileList, setSignatureFileList] = useState([]);
  const [existingSignature, setExistingSignature] = useState(null);
  const [cnpjApiConfig, setCnpjApiConfig] = useState();

  const getInstructorById = async (editId) => {
    setLoading(true);

    const res = await api
      .get(`/Instructor?id=${editId}`)
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os dados do instrutor!');
      });

    res.workDays = res.workDays?.split(',');
    res.birthDate = res.birthDate ? moment(res.birthDate) : null;
    res.businessHour = [moment(res.startBusinessHour), moment(res.endBusinessHour)];
    res.breakTime = [moment(res.breakStart), moment(res.breakFinish)];
    res.trainingKind = res?.trainingKind?.map(({ id }) => id);
    res.documents = res?.documents?.map(
      ({ type: { id: type }, number, validity, downloadUrls, verified }) => ({
        type,
        number,
        validity: moment(validity),
        downloadUrls,
        verified,
      })
    );

    setExistingSignature(res.signature);

    form.setFieldsValue(applyRegisterCustomFields(res));
    setLoading(false);
  };

  const submit = async (values) => {
    setLoading(true);
    const data = { ...values };

    if (values.businessHour && values.businessHour !== undefined) {
      data.startBusinessHour = moment.utc(values.businessHour[0]).format('YYYY-MM-DDTHH:mm:ss');
      data.endBusinessHour = moment.utc(values.businessHour[1]).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (values.breakTime && values.breakTime !== undefined) {
      data.breakStart = moment.utc(values.breakTime[0]).format('YYYY-MM-DDTHH:mm:ss');
      data.breakFinish = moment.utc(values.breakTime[1]).format('YYYY-MM-DDTHH:mm:ss');
    }

    data.workDays = data.workDays?.toString();
    data.birthDate = moment(data.birthDate);

    data.trainingKind = data.trainingKind?.map((trainingId) => {
      const [training] = trainingsOptions?.filter(({ value: id }) => id === trainingId);

      return {
        id: training.value,
        name: training.label,
      };
    });

    await CompanyFunctions.saveDocuments(data, 'instructor');

    if (signatureFileList.length > 0) {
      const [file] = signatureFileList;
      const docName = `signature_${Utils.generateUUID()}`;

      await uploadFiles(file.originFileObj, 'instructor', data.id, docName).then((res) => {
        data.signature = {
          label: file.name,
          name: docName,
          url: res,
        };
      });
    }

    const httpMethod = editId ? 'put' : 'post';
    await api[httpMethod]('/Instructor', data)
      .then(() => {
        message.success(`Dados ${editId ? 'atualizados' : 'salvos'}!`);
        form.resetFields();

        if (editId) {
          getInstructorById(editId);
        }

        setLoading(false);
        setScreenModified(false);
      })
      .catch((error) => {
        Utils.logError(error);
        let errorMessage = 'Erro ao enviar os dados do Instrutor!';

        if (error?.errors?.length > 0 && error.errors[0]?.message.includes('Email')) {
          errorMessage = error.errors[0].message;
        } else if (error?.message?.includes('Email')) {
          errorMessage = error.message;
        }

        message.error(`Oops. ${errorMessage}`);
        setLoading(false);
      });
  };

  const getAdressByCEP = async (cep) => {
    if (cep.replace(/[-_]/g, '')?.length === 8) {
      const address = await axios
        .get(`https://viacep.com.br/ws/${cep}/json`)
        .then((res) => res.data)
        .catch((error) => {
          Utils.logError(error);
          message.error('Erro ao buscar CEP!');
        });

      const data = {};
      data.personalStreet = address?.logradouro;
      data.personalDistrict = address?.bairro;
      data.personalComplement = address?.complemento;
      data.personalCity = address?.localidade;
      data.personalState = address?.uf;

      form.setFieldsValue({ ...form.getFieldsValue(), ...data });
    }
  };

  const getDocumentTypes = async () => {
    const documentTypes = await api
      .get(
        '/DocumentType?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os tipos de documento!');
      });

    const mappedDocumentTypes = documentTypes?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    setDocumentTypeOptions(mappedDocumentTypes);
    return mappedDocumentTypes;
  };

  const getTrainings = async () => {
    const trainings = await api
      .get('/Trainings')
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os tipos de treinamento!');
      });

    const mappedTrainings = trainings?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    mappedTrainings?.unshift({ value: 'selectAll', label: 'Selecionar todos' });
    setTrainingsOptions(mappedTrainings);
  };

  const getTrainingCenters = async () => {
    const trainingCenters = await api
      .get(
        '/TrainingCenter?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Centro de Treinamento&filters[1].Field=Status&filters[1].Condition=EQUAL&filters[1].Value=Ativo'
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os centros de treinamento!');
      });

    const mappedTrainingCenters = trainingCenters?.map(({ id: value, commercialName: label }) => ({
      label,
      value,
    }));

    mappedTrainingCenters?.unshift({ value: 'selectAll', label: 'Selecionar todos' });
    setTrainingCenterOptions(mappedTrainingCenters);
  };

  const fetchSettings = async () => {
    const docTypes = await getDocumentTypes();

    const res = await api
      .get(`/Settings?id=1`)
      .then(async (res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os documentos obrigatórios!');
      });

    const decryptedSettings = Utils.decryptSettings(res);

    setCnpjApiConfig({
      url: decryptedSettings.cnpjApiUrl,
      token: decryptedSettings.cnpjApiToken,
    });

    const reqDocsIds =
      decryptedSettings.requiredDocumentsInstructor
        ?.split(',')
        ?.map((item) => parseInt(item, 10)) ?? [];

    const reqDocs = docTypes
      ?.filter(({ value }) => reqDocsIds.includes(value))
      ?.map(({ label }) => label);

    setRequiredDocuments(reqDocs);
  };

  const handleSignatureChange = (info) => {
    setSignatureFileList(info.fileList);
  };

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields, canHandle }) => {
        if (name === 'Instructor') {
          canHandleInstructor = canHandle;
          fields.forEach(({ name, access, isRequired }) => {
            permissions[name] = { access, isRequired };
          });
        }
      }
    );
    setFieldsPermissions(permissions);
  }, []);

  useEffect(() => {
    getTrainings();
    getTrainingCenters();
    fetchSettings();

    Inputmask({ mask: '(99) 9{1,9}' }).mask(document.getElementById('phone2'));
    Inputmask({ mask: '(99) 9{1,9}' }).mask(document.getElementById('phone1'));
    Inputmask({ mask: '99999-999' }).mask(document.getElementById('cep'));
    Inputmask({ mask: '99999-999' }).mask(document.getElementById('personalCep'));
    Inputmask({ mask: '99.999.999/9999-99' }).mask(document.getElementById('cnpj'));

    if (editId) {
      getInstructorById(editId);
    }
  }, []);

  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'taskTitle',
        title: 'Treinamentos',
        ...getColumnSearchProps('taskTitle', 'Treinamentos'),
        sorter: (a, b) => a.taskTitle.localeCompare(b.taskTitle),
        sortDirections: ['descend', 'ascend'],
      },
      {
        dataIndex: 'taskStage',
        title: 'Status',
        width: '25%',
        ...getColumnSearchProps('taskStage', 'Status'),
        sorter: (a, b) => a.taskStage.name.localeCompare(b.taskStage.name),
        sortDirections: ['descend', 'ascend'],
        render: (taskStage) => taskStage.name,
      },
      {
        dataIndex: 'date',
        title: 'Data',
        width: '20%',
        ...getColumnSearchProps('date', 'Data'),
        sorter: (a, b) => a.date.localeCompare(b.date),
        sortDirections: ['descend', 'ascend'],
        render: (date) => moment(date).format('DD/MM/YYYY'),
      },
    ];
    return columns;
  };

  const extraTabPanes = () => [
    <Tabs.TabPane tab="Documentos" key="documentsData" forceRender>
      <Form.List name="documents">
        {(fields, { add, remove }) => (
          <>
            {requiredDocuments?.length > 0 && (
              <div>
                <h3>Documentos Obrigatórios</h3>
                <p style={{ margin: 0 }}>{requiredDocuments?.join(' / ')}</p>
              </div>
            )}

            <Button
              style={{
                marginTop: 15,
                marginBottom: 15,
                width: 200,
              }}
              type="dashed"
              onClick={() => {
                add();
                setScreenModified(true);
              }}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Documento
            </Button>
            <Row gutter={[24]}>
              {fields.map(({ key, name, ...restField }) => (
                <Col key={key} span={8}>
                  <Card
                    extra={
                      <Popconfirm
                        title="Deseja mesmo excluir?"
                        onConfirm={() => {
                          if (form.getFieldValue('documents')[name]?.downloadUrls) {
                            CompanyFunctions.deleteDocumentFromStorage(form, 'instructor', name);
                            remove(name);

                            submit(form.getFieldsValue());
                            setScreenModified(false);
                          } else {
                            remove(name);
                            setScreenModified(true);
                          }
                        }}
                        okText="Sim"
                        cancelText="Não"
                      >
                        <CloseOutlined />
                      </Popconfirm>
                    }
                    style={{
                      backgroundColor: '#ffffff00',
                      borderColor: '#b7b7b7',
                      borderRadius: 16,
                      marginBottom: 10,
                    }}
                  >
                    {canHandleInstructor && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'verified']}
                          valuePropName="checked"
                          initialValue={true}
                        >
                          <Checkbox>Verificado</Checkbox>
                        </Form.Item>
                      </Col>
                    )}
                    {showField('DocumentType') && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'type']}
                          label="Tipo de documento"
                          rules={[
                            {
                              required: fieldsPermissions?.DocumentType.isRequired,
                              message: 'Campo obrigatório!',
                            },
                          ]}
                          getValueFromEvent={(_, object) => {
                            if (!object) return null;

                            return {
                              ...object,
                              name: object.label,
                              id: object.value,
                            };
                          }}
                        >
                          <Select
                            options={documentTypeOptions}
                            allowClear
                            placeholder="Selecione"
                            optionFilterProp="label"
                            showSearch
                            dropdownStyle={{ borderRadius: 16 }}
                            disabled={fieldsPermissions?.DocumentType.access !== 2}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {showField('DocumentNumber') && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'number']}
                          label="Nº documento"
                          rules={[
                            {
                              required: fieldsPermissions?.DocumentNumber.isRequired,
                              message: 'Campo obrigatório!',
                            },
                          ]}
                        >
                          <Input disabled={fieldsPermissions?.DocumentNumber.access !== 2} />
                        </Form.Item>
                      </Col>
                    )}
                    {showField('DocumentValidity') && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'validity']}
                          label="Validade"
                          rules={[
                            {
                              required: fieldsPermissions?.DocumentValidity.isRequired,
                              message: 'Campo obrigatório!',
                            },
                          ]}
                        >
                          <DatePicker
                            format="DD-MM-YYYY"
                            style={{
                              borderRadius: 16,
                            }}
                            disabled={fieldsPermissions?.DocumentValidity.access !== 2}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {showField('UploadFiles') &&
                      form.getFieldValue('documents')[name]?.downloadUrls && (
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'downloadUrls']}
                            label
                            style={{
                              textAlign: 'center',
                            }}
                            rules={[
                              {
                                required: fieldsPermissions?.UploadFiles.isRequired,
                                message: 'Campo obrigatório!',
                              },
                            ]}
                          >
                            <List
                              size="small"
                              header={<div>Arquivos</div>}
                              bordered
                              dataSource={form.getFieldValue('documents')[name]?.downloadUrls}
                              renderItem={({ label, url }) => (
                                <List.Item>
                                  <a href={url} target="blank" style={{ wordBreak: 'break-word' }}>
                                    {label}
                                  </a>
                                </List.Item>
                              )}
                            />
                          </Form.Item>
                        </Col>
                      )}

                    {showField('UploadFiles') &&
                      !form.getFieldValue('documents')[name]?.downloadUrls && (
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'uploadFiles']}
                            label
                            style={{
                              textAlign: 'center',
                            }}
                            rules={[
                              {
                                required: fieldsPermissions?.UploadFiles.isRequired,
                                message: 'Campo obrigatório!',
                              },
                            ]}
                          >
                            <Upload
                              multiple
                              beforeUpload={() => false}
                              disabled={fieldsPermissions?.UploadFiles.access !== 2}
                            >
                              <Button icon={<UploadOutlined />}>Upload de arquivos</Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      )}
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Form.List>
    </Tabs.TabPane>,
    <Tabs.TabPane tab="Histórico de Treinamentos" key="trainingHistoryData" forceRender>
      <TableAntd
        columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
        routePermissions="Instructor"
        requestName="TrainingHistory?filters[1].Field=Status&filters[1].Condition=NUMBER.IN&filters[1].Value=3,4"
        route="/Instrutor"
        toggleStatusRoute="/Company"
        isNotAction={true}
      />
    </Tabs.TabPane>,
  ];

  const widgetMap = {
    Cnpj: () =>
      showField('Cnpj') && (
        <Col span={6}>
          <Form.Item
            label="CNPJ"
            name="cnpj"
            rules={[
              {
                required: fieldsPermissions?.Cnpj.isRequired,
                validator: (rule, value) => {
                  const isValid = Utils.validateCNPJ(value);
                  if (!isValid && fieldsPermissions?.Cnpj.isRequired) {
                    return Promise.reject(new Error(`CNPJ Inválido`));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Search
              id="cnpj"
              placeholder="00.000.000/0000-00"
              disabled={fieldsPermissions?.Cnpj.access !== 2}
              onSearch={(val) => CompanyFunctions.fetchCnpj(val, form, cnpjApiConfig)}
            />
          </Form.Item>
        </Col>
      ),
    Name: () =>
      showField('Name') && (
        <Col span={6}>
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: fieldsPermissions?.Name.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Name.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Rg: () =>
      showField('Rg') && (
        <Col span={6}>
          <Form.Item
            label="RG"
            name="rg"
            rules={[
              {
                required: fieldsPermissions?.Rg.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input placeholder="00.000.000-0" disabled={fieldsPermissions?.Rg.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Cpf: () =>
      showField('Cpf') && (
        <Col span={6}>
          <Form.Item
            label="CPF"
            name="cpf"
            rules={[
              {
                required: fieldsPermissions?.Cpf.isRequired,
                validator: (rule, value = '') => {
                  const isValid = Utils.validateCPF(value);
                  if (!isValid && value.length > 0) {
                    return Promise.reject(new Error(`CPF Inválido`));
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              id="cpf"
              placeholder="000.000.000-00"
              disabled={fieldsPermissions?.Cpf.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    CommercialName: () =>
      showField('CommercialName') && (
        <Col span={6}>
          <Form.Item
            label="Nome Empresa"
            name="commercialName"
            rules={[
              {
                required: fieldsPermissions?.CommercialName.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.CommercialName.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Street: () =>
      showField('Street') && (
        <Col span={7}>
          <Form.Item
            label="Rua"
            name="street"
            rules={[
              {
                required: fieldsPermissions?.Street.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Street.access !== 2} />
          </Form.Item>
        </Col>
      ),
    AddressNumber: () =>
      showField('AddressNumber') && (
        <Col span={3}>
          <Form.Item
            label="Número"
            name="addressNumber"
            rules={[
              {
                required: fieldsPermissions?.AddressNumber.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber disabled={fieldsPermissions?.AddressNumber.access !== 2} />
          </Form.Item>
        </Col>
      ),
    District: () =>
      showField('District') && (
        <Col span={7}>
          <Form.Item
            label="Bairro"
            name="district"
            rules={[
              {
                required: fieldsPermissions?.District.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.District.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Cep: () =>
      showField('Cep') && (
        <Col span={7}>
          <Form.Item
            label="CEP"
            name="cep"
            rules={[
              {
                required: fieldsPermissions?.Cep.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="cep"
              placeholder="00000-000"
              disabled={fieldsPermissions?.Cep.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    Complement: () =>
      showField('Complement') && (
        <Col span={8}>
          <Form.Item
            label="Complemento"
            name="complement"
            rules={[
              {
                required: fieldsPermissions?.Complement.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Complement.access !== 2} />
          </Form.Item>
        </Col>
      ),
    City: () =>
      showField('City') && (
        <Col span={8}>
          <Form.Item
            label="Cidade"
            name="city"
            rules={[
              {
                required: fieldsPermissions?.City.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.City.access !== 2} />
          </Form.Item>
        </Col>
      ),
    State: () =>
      showField('State') && (
        <Col span={8}>
          <Form.Item
            label="Estado"
            name="state"
            rules={[
              {
                required: fieldsPermissions?.State.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.State.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Email: () =>
      showField('Email') && (
        <Col span={8}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: fieldsPermissions?.Email.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              placeholder="exemplo@email.com"
              disabled={fieldsPermissions?.Email.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    Phone1: () =>
      showField('Phone1') && (
        <Col span={8}>
          <Form.Item
            label="Telefone 1"
            name="phone1"
            rules={[
              {
                required: fieldsPermissions?.Phone1.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="phone1"
              placeholder="(00) 0000-0000"
              disabled={fieldsPermissions?.Phone1.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    Phone2: () =>
      showField('Phone2') && (
        <Col span={8}>
          <Form.Item
            label="Telefone 2"
            name="phone2"
            rules={[
              {
                required: fieldsPermissions?.Phone2.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="phone2"
              placeholder="(00) 0000-0000"
              disabled={fieldsPermissions?.Phone2.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    BirthDate: () =>
      showField('BirthDate') && (
        <Col span={6}>
          <Form.Item
            label="Data de nascimento"
            name="birthDate"
            rules={[
              {
                required: fieldsPermissions?.BirthDate.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <DatePicker
              placeholder="00-00-0000"
              format="DD-MM-YYYY"
              style={{ borderRadius: 16 }}
              disabled={fieldsPermissions?.BirthDate.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    BusinessHour: () =>
      showField('BusinessHour') && (
        <Col span={6}>
          <Form.Item
            label="Horário de trabalho"
            name="businessHour"
            rules={[
              {
                required: fieldsPermissions?.BusinessHour.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <TimePicker.RangePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={fieldsPermissions?.BusinessHour.access !== 2 || loading}
              ranges={{
                '08h às 18h': [
                  moment().startOf('day').add(8, 'hours'),
                  moment().startOf('day').add(18, 'hours'),
                ],
              }}
            />
          </Form.Item>
        </Col>
      ),
    BreakTime: () =>
      showField('BreakTime') && (
        <Col span={6}>
          <Form.Item
            label="Horário de intervalo"
            name="breakTime"
            rules={[
              {
                required: fieldsPermissions?.BreakTime.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <TimePicker.RangePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={fieldsPermissions?.BreakTime.access !== 2 || loading}
              ranges={{
                '12h às 13h': [
                  moment().startOf('day').add(12, 'hours'),
                  moment().startOf('day').add(13, 'hours'),
                ],
              }}
            />
          </Form.Item>
        </Col>
      ),
    Qualification: () =>
      showField('Qualification') && (
        <Col span={6}>
          <Form.Item
            label="Formação profissional"
            name="qualification"
            rules={[
              {
                required: fieldsPermissions?.Qualification.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Qualification.access !== 2} />
          </Form.Item>
        </Col>
      ),
    WorkDays: () =>
      showField('WorkDays') && (
        <Col span={6}>
          <Form.Item
            label="Dias de trabalho"
            name="workDays"
            rules={[
              {
                required: fieldsPermissions?.WorkDays.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              options={workDaysOptions}
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.WorkDays.access !== 2}
              onChange={(values) =>
                Utils.handleSelectAllChange(values, workDaysOptions, 'workDays', form)
              }
            />
          </Form.Item>
        </Col>
      ),
    TrainingKind: () =>
      showField('TrainingKind') && (
        <Col span={6}>
          <Form.Item
            label="Tipos de treinamento"
            name="trainingKind"
            rules={[
              {
                required: fieldsPermissions?.TrainingKind.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={trainingsOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.TrainingKind.access !== 2}
              onChange={(values) =>
                Utils.handleSelectAllChange(values, trainingsOptions, 'trainingKind', form)
              }
            />
          </Form.Item>
        </Col>
      ),
    TrainingCenters: () =>
      showField('TrainingCenters') && (
        <Col span={6}>
          <Form.Item
            label="Centros de Treinamento"
            name="workTrainingCenters"
            rules={[
              {
                required: fieldsPermissions?.TrainingCenters.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={trainingCenterOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.TrainingCenters.access !== 2}
              onChange={(values) =>
                Utils.handleSelectAllChange(
                  values,
                  trainingCenterOptions,
                  'workTrainingCenters',
                  form
                )
              }
            />
          </Form.Item>
        </Col>
      ),
    MunicipalRegistration: () =>
      showField('MunicipalRegistration') && (
        <Col span={6}>
          <Form.Item
            label="Inscrição municipal para guia RPA"
            name="municipalRegistration"
            rules={[
              {
                required: fieldsPermissions?.MunicipalRegistration.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input type="number" disabled={fieldsPermissions?.MunicipalRegistration.access !== 2} />
          </Form.Item>
        </Col>
      ),
    DescriptionInstructor: () =>
      showField('DescriptionInstructor') && (
        <Col span={12}>
          <Form.Item
            label="Observações"
            name="descriptionInstructor"
            rules={[
              {
                required: fieldsPermissions?.DescriptionInstructor.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input.TextArea
              rows={12}
              disabled={fieldsPermissions?.DescriptionInstructor.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    Signature: () =>
      showField('Signature') && (
        <Col span={6}>
          <Form.Item
            label="Assinatura"
            name="signature"
            rules={[
              {
                required: fieldsPermissions?.Signature.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            {!existingSignature && (
              <Upload
                maxCount={1}
                onChange={handleSignatureChange}
                fileList={signatureFileList}
                beforeUpload={() =>
                  // Previne upload automático
                  false
                }
              >
                <Button icon={<UploadOutlined />}>Selecionar arquivo</Button>
              </Upload>
            )}
            {existingSignature && (
              <div>
                {existingSignature.label}
                <Popconfirm
                  title="Tem certeza que deseja deletar a assinatura?"
                  onConfirm={async () => {
                    await deleteFileDocuments(existingSignature.name, 'instructor', editId);

                    const newData = form.getFieldsValue();
                    newData.signature = null;
                    await submit(newData);
                  }}
                  okText="Sim"
                  cancelText="Não"
                  overlayStyle={{
                    zIndex: 9999,
                  }}
                  disabled={loading}
                >
                  <DeleteOutlined
                    type="link"
                    style={{ color: 'red', marginLeft: 5, cursor: 'pointer' }}
                  />
                </Popconfirm>
              </div>
            )}
          </Form.Item>
        </Col>
      ),
    CarModel: () =>
      showField('CarModel') && (
        <Col span={8}>
          <Form.Item
            label="Modelo do veículo"
            name="carModel"
            rules={[
              {
                required: fieldsPermissions?.CarModel.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.CarModel.access !== 2} />
          </Form.Item>
        </Col>
      ),
    CarColor: () =>
      showField('CarColor') && (
        <Col span={4}>
          <Form.Item
            label="Cor"
            name="carColor"
            rules={[
              {
                required: fieldsPermissions?.CarColor.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.CarColor.access !== 2} />
          </Form.Item>
        </Col>
      ),
    CarLicensePlate: () =>
      showField('CarLicensePlate') && (
        <Col span={4}>
          <Form.Item
            label="Placa"
            name="carLicensePlate"
            rules={[
              {
                required: fieldsPermissions?.CarLicensePlate.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.CarLicensePlate.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Bank: () =>
      showField('Bank') && (
        <Col span={8}>
          <Form.Item
            label="Banco"
            name="bank"
            rules={[
              {
                required: fieldsPermissions?.Bank.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Bank.access !== 2} />
          </Form.Item>
        </Col>
      ),
    Agency: () =>
      showField('Agency') && (
        <Col span={4}>
          <Form.Item
            label="Agência"
            name="agency"
            rules={[
              {
                required: fieldsPermissions?.Agency.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Agency.access !== 2} />
          </Form.Item>
        </Col>
      ),
    TransactionAccount: () =>
      showField('TransactionAccount') && (
        <Col span={4}>
          <Form.Item
            label="Conta corrente"
            name="transactionAccount"
            rules={[
              {
                required: fieldsPermissions?.TransactionAccount.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.TransactionAccount.access !== 2} />
          </Form.Item>
        </Col>
      ),
    PIX: () =>
      showField('PIX') && (
        <Col span={8}>
          <Form.Item
            label="Chave recebimento - Pix"
            name="pix"
            rules={[
              {
                required: fieldsPermissions?.PIX.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.PIX.access !== 2} />
          </Form.Item>
        </Col>
      ),
    PersonalCep: () =>
      showField('PersonalCep') && (
        <Col span={8}>
          <Form.Item
            name="personalCep"
            label="CEP"
            rules={[
              {
                required: fieldsPermissions?.PersonalCep.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="personalCep"
              maxLength={9}
              placeholder="00000-000"
              onChange={(e) => getAdressByCEP(e.target.value)}
              disabled={fieldsPermissions?.PersonalCep.access !== 2}
            />
          </Form.Item>
        </Col>
      ),
    PersonalState: () =>
      showField('PersonalState') && (
        <Col span={8}>
          <Form.Item
            name="personalState"
            label="Estado"
            rules={[
              {
                required: fieldsPermissions?.PersonalState.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.PersonalState.access !== 2} />
          </Form.Item>
        </Col>
      ),
    PersonalCity: () =>
      showField('PersonalCity') && (
        <Col span={8}>
          <Form.Item
            name="personalCity"
            label="Cidade"
            rules={[
              {
                required: fieldsPermissions?.PersonalCity.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.PersonalCity.access !== 2} />
          </Form.Item>
        </Col>
      ),
    PersonalDistrict: () =>
      showField('PersonalDistrict') && (
        <Col span={8}>
          <Form.Item
            name="personalDistrict"
            label="Bairro"
            rules={[
              {
                required: fieldsPermissions?.PersonalDistrict.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.PersonalDistrict.access !== 2} />
          </Form.Item>
        </Col>
      ),
    PersonalStreet: () =>
      showField('PersonalStreet') && (
        <Col span={8}>
          <Form.Item
            name="personalStreet"
            label="Rua"
            rules={[
              {
                required: fieldsPermissions?.PersonalStreet.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.PersonalStreet.access !== 2} />
          </Form.Item>
        </Col>
      ),
    PersonalComplement: () =>
      showField('PersonalComplement') && (
        <Col span={8}>
          <Form.Item
            name="personalComplement"
            label="Complemento"
            rules={[
              {
                required: fieldsPermissions?.PersonalComplement.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.PersonalComplement.access !== 2} />
          </Form.Item>
        </Col>
      ),
  };

  return (
    <Form
      form={form}
      disabled={loading}
      name="InstructorRegister"
      onFinish={submit}
      layout="vertical"
      autoComplete="off"
      onChange={() => setScreenModified(true)}
    >
      <div className="form-toolbar">
        {screenModified && (
          <Popconfirm
            title="Deseja mesmo voltar?"
            onConfirm={() => navigate(-1)}
            okText="Sim"
            cancelText="Não"
          >
            <Button>Voltar</Button>
          </Popconfirm>
        )}
        {!screenModified && <Button onClick={() => navigate(-1)}>Voltar</Button>}
        <Button loading={loading} block type="primary" htmlType="submit">
          Salvar
        </Button>
      </div>

      {/* Campos invisiveis */}
      <Form.Item className="input-hidden" label="Id" name="id">
        <Input />
      </Form.Item>
      <RegisterLayoutBody
        fieldLayout={fieldLayout}
        fieldsPermissions={fieldsPermissions}
        roleId={roleId}
        widgetMap={widgetMap}
        form={form}
        loading={loading}
        extraFields={<Tabs>{extraTabPanes()}</Tabs>}
        padraoFields={
          <Tabs>
            <Tabs.TabPane tab="Dados Empresa" key="generalData">
              <Row gutter={[24]}>
                {widgetMap.Cnpj()}

                {widgetMap.Name()}

                {widgetMap.Rg()}

                {widgetMap.Cpf()}

                {widgetMap.CommercialName()}

                {widgetMap.Street()}

                {widgetMap.AddressNumber()}

                {widgetMap.District()}

                {widgetMap.Cep()}

                {widgetMap.Complement()}

                {widgetMap.City()}

                {widgetMap.State()}

                {widgetMap.Email()}

                {widgetMap.Phone1()}

                {widgetMap.Phone2()}
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Dados Complementares" key="additionalData" forceRender>
              <Row gutter={[24]}>
                {widgetMap.BirthDate()}

                {widgetMap.BusinessHour()}

                {widgetMap.BreakTime()}

                {widgetMap.Qualification()}

                {widgetMap.WorkDays()}

                {widgetMap.TrainingKind()}

                {widgetMap.TrainingCenters()}

                {widgetMap.MunicipalRegistration()}

                {widgetMap.DescriptionInstructor()}

                {widgetMap.Signature()}
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Veículo / Banco / Endereço Pessoal" key="addressData" forceRender>
              <Row gutter={[24]}>
                {widgetMap.CarModel()}

                {widgetMap.CarColor()}

                {widgetMap.CarLicensePlate()}

                {widgetMap.Bank()}

                {widgetMap.Agency()}

                {widgetMap.TransactionAccount()}

                {widgetMap.PIX()}

                {widgetMap.PersonalCep()}

                {widgetMap.PersonalState()}

                {widgetMap.PersonalCity()}

                {widgetMap.PersonalDistrict()}

                {widgetMap.PersonalStreet()}

                {widgetMap.PersonalComplement()}
              </Row>
            </Tabs.TabPane>
            {extraTabPanes()}
          </Tabs>
        }
      />
    </Form>
  );
}

const InstructorRegister = memo(InstructorRegisterPage);
export default InstructorRegister;
